import styled from "styled-components";
import { device } from "../../services";
import { H } from "./Section";

// default html styles for h1 tag, use this component instead of h1
const Heading1 = styled(H)`
  font-size: 64px;
  line-height: 76px;

  @media screen and ${device.laptop} {
    font-size: 48px;
    line-height: 58px;
  }

  @media screen and ${device.mobile} {
    font-size: 34px;
    line-height: 44px;
  }
`;

// default html styles for h2 tag, use this component instead of h2
const Heading2 = styled(H)`
  font-size: 48px;
  line-height: 58px;

  @media screen and ${device.laptop} {
    font-size: 34px;
    line-height: 44px;
  }

  @media screen and ${device.mobile} {
    font-size: 28px;
    line-height: 38px;
  }
`;

// default html styles for h3 tag, use this component instead of h3
const Heading3 = styled(H)`
  font-size: 34px;
  line-height: 44px;

  @media screen and ${device.laptop} {
    font-size: 28px;
    line-height: 38px;
  }

  @media screen and ${device.mobile} {
    font-size: 24px;
    line-height: 34px;
  }
`;

// default html styles for h4 tag, use this component instead of h4
const Heading4 = styled(H)`
  font-size: 28px;
  line-height: 38px;

  @media screen and ${device.laptop} {
    font-size: 24px;
    line-height: 34px;
  }

  @media screen and ${device.mobile} {
    font-size: 22px;
    line-height: 32px;
  }
`;

// default html styles for h5 tag, use this component instead of h5
const Heading5 = styled(H)`
  font-size: 24px;
  line-height: 34px;

  @media screen and ${device.laptop} {
    font-size: 22px;
    line-height: 32px;
  }

  @media screen and ${device.mobile} {
    font-size: 20px;
    line-height: 30px;
  }
`;

// default html styles for h6 tag, use this component instead of h6
const Heading6 = styled(H)`
  font-size: 22px;
  line-height: 32px;

  @media screen and ${device.laptop} {
    font-size: 20px;
    line-height: 30px;
  }

  @media screen and ${device.mobile} {
    font-size: 16px;
    line-height: 26px;
  }
`;

export { Heading1, Heading2, Heading3, Heading4, Heading5, Heading6 };
